import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import './i18n/config.ts'

// Hide loading spinner when React app is ready
const hideLoadingSpinner = () => {
  const spinner = document.getElementById('loading-spinner')
  if (spinner) {
    spinner.style.opacity = '0'
    spinner.style.transition = 'opacity 0.5s ease-out'
    setTimeout(() => {
      spinner.style.display = 'none'
    }, 500)
  }
}

// Render the app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)

// Hide spinner after React has mounted
setTimeout(hideLoadingSpinner, 300)
